import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { IconButton, ListItem, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  menuItemName: {
    color: theme.palette.text.main,
    background: theme.palette.action.hover,
    ...theme.typography.body2,
  },
  menuItem: {
    outline: 'none',
    textOverflow: 'ellipsis',
  },
}));

function MassActionItemMenu({ request, options, actions }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();

  function handleClose() {
    setAnchorEl(null);
  }

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  const { classes } = useStyles();

  return (
    <>
      <IconButton
        style={{ padding: '4px' }}
        aria-owns={anchorEl ? `item-menu-${request.id}` : null}
        aria-haspopup="true"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          handleClick(e);
        }}
        size="large"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        MenuListProps={{ disablePadding: true }}
        id={`item-menu-${request.id}`}
        value
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={e => {
          e.preventDefault();
          e.stopPropagation();
          handleClose();
        }}
        PaperProps={{
          style: {
            minWidth: 150,
          },
        }}
      >
        <ListItem className={classes.menuItemName} divider>
          {request.name}
        </ListItem>
        {options.map(option => (
          <MenuItem
            dense
            className={classes.menuItem}
            key={option}
            onClick={() => {
              actions[option]();
            }}
          >
            {t(`smartmessaging.massAction.requestList.item.${option}`)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

MassActionItemMenu.propTypes = {
  request: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
};

export default MassActionItemMenu;
